import { useQuery } from '@tanstack/react-query';

import { fetchResolveICD10, type ResolveICD10ResponseT } from '../api/searchICD10.js';
import { labsKeys } from './keys.js';

/**
 * Resolve one or more ICD-10 codes to their authoritative descriptions.
 *
 * Used to hydrate a bare code (e.g. one carried by a ``diagnose`` proposed
 * action) into a full ``ICD10CodeT`` for display. Disabled when no codes are
 * provided.
 */
export function useResolveICD10Query(codes: string[], enabled = true) {
  return useQuery<ResolveICD10ResponseT>({
    queryKey: labsKeys.icd10Resolve(codes),
    queryFn: ({ signal }) => fetchResolveICD10(codes, signal),
    enabled: enabled && codes.length > 0,
    staleTime: 300_000,
  });
}
